/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="1" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#fff" text-color="#333" active-text-color="#3E74E1">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo@2x.png" alt="">
    </div>
      <div class="navbox" v-for="menu in allmenu" >
      <el-submenu v-if="menu.hasThird!='N'" :key="menu.menuid" :index="menu.menuname">
      <template slot="title" >
          <i class="iconfont" :class="menu.icon" v-if="menu.icon"></i>
          <i class="iconfonts" :class="menu.icons" v-else></i>
          <span class="yc">{{menu.menuname}}</span>
        </template>
        <el-menu-item-group >
          <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
            <i class="iconfont" :class="chmenu.icon"></i>
            <span>{{chmenu.menuname}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
        <el-menu-item  :index="'/'+menu.url" :key="menu.menuid" v-else>
              <i class="iconfont" :class="menu.icon" v-if="menu.icon"></i>
              <i class="iconfonts" :class="menu.icons" v-else></i>
              <span class="yc">{{menu.menuname}}</span>
        </el-menu-item>
    </div>



  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icons: 'el-icon-house',
          menuname: 'AegisAI管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: 'el-icon-house',
              menuname: 'chatWEB',
              hasThird: 'N',
              url: 'chat/web',
              menus: null
            },
            {
              menuid: 3,
              icon: 'el-icon-house',
              menuname: 'chatBOT',
              hasThird: 'N',
              url: 'chat/bot',
              menus: null
            },
            {
              menuid: 4,
              icon: 'el-icon-house',
              menuname: 'chatAPI',
              hasThird: 'N',
              url: 'chat/api',
              menus: null
            }
          ]
        },
        // {
        //   menuid: 33,
        //   icon: 'li-icon-dingdanguanli',
        //   menuname: '订单管理',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 34,
        //       icon: 'icon-order-manage',
        //       menuname: '交易订单',
        //       hasThird: 'N',
        //       url: 'pay/Order',
        //       menus: null
        //     }
        //   ]
        // },
        
        // {
        //   menuid: 128,
        //   icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        //   menuname: '支付管理',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 129,
        //       icon: 'icon-provider-manage',
        //       menuname: '支付配置信息',
        //       hasThird: 'N',
        //       url: 'machine/MachineConfig',
        //       menus: null
        //     },
        //     {
        //       menuid: 175,
        //       icon: 'icon-provider-manage',
        //       menuname: '支付配置',
        //       hasThird: 'N',
        //       url: 'pay/Config',
        //       menus: null
        //     }
        //   ]
        // },
        
        {
          menuid: 146,
          icon: '',
          icons: 'el-icon-collection',
          menuname: '知识库管理',
          hasThird: 'N',
          url: 'knowledge/index',
        },
        {
          menuid: 147,
          icon: '',
          icons: 'el-icon-s-data',
          menuname: '访问数据',
          hasThird: 'N',
          url: 'data/data',
        },
        {
          menuid: 149,
          icon: '',
          icons: 'el-icon-notebook-2',
          menuname: '开放平台策略',
          hasThird: 'N',
          url: 'strategy/index',
        },
        {
          menuid: 150,
          icon: '',
          icons: 'el-icon-position',
          menuname: '大模型接入',
          hasThird: 'N',
          url: 'largemodel/setting',
        },
        {
          menuid: 151,
          icon: '',
          icons: 'el-icon-tickets',
          menuname: 'API接口文档',
          hasThird: 'N',
          url: 'system/api',
        },
        // {
        //   menuid: 71,
        //   icon: 'li-icon-xitongguanli',
        //   menuname: '系统管理',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 72,
        //       icon: 'icon-cus-manage',
        //       menuname: '用户管理',
        //       hasThird: 'N',
        //       url: 'system/user',
        //       menus: null
        //     },
        //     // {
        //     //   menuid: 174,
        //     //   icon: 'icon-cms-manage',
        //     //   menuname: '菜单管理',
        //     //   hasThird: 'N',
        //     //   url: 'system/Module',
        //     //   menus: null
        //     // },
        //     {
        //       menuid: 73,
        //       icon: 'icon-news-manage',
        //       menuname: '角色管理',
        //       hasThird: 'N',
        //       url: 'system/Role',
        //       menus: null
        //     },
        //     // {
        //     //   menuid: 74,
        //     //   icon: 'icon-cs-manage',
        //     //   menuname: '公司管理',
        //     //   hasThird: 'N',
        //     //   url: 'system/Dept',
        //     //   menus: null
        //     // },
        //     // {
        //     //   menuid: 75,
        //     //   icon: 'icon-promotion-manage',
        //     //   menuname: '系统环境变量',
        //     //   hasThird: 'N',
        //     //   url: 'system/Variable',
        //     //   menus: null
        //     // },
        //     {
        //       menuid: 76,
        //       icon: 'icon-cms-manage',
        //       menuname: '权限管理',
        //       hasThird: 'N',
        //       url: 'system/Permission',
        //       menus: null
        //     }
        //   ]
        // }
        // {
        //   menuid: 150,
        //   icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        //   menuname: '图表',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 159,
        //       icon: 'icon-provider-manage',
        //       menuname: '数据可视化',
        //       hasThird: 'N',
        //       url: 'charts/statistics',
        //       menus: null
        //     }
        //   ]
        // }
      ],
      msg: 'success'
    }
          this.allmenu = res.data
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style >
.el-menu--collapse .navbox .yc{
  display: none !important;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 29px;
  width: 138px;
}
.iconfonts{
    font-size: 20px !important;
    font-style: normal !important;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue